import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowRight, Phone } from 'lucide-react';
import heroBg from '@/assets/hero-bg.jpg';

const Hero = () => {
  return (
    <div className="relative text-white bg-cover bg-center bg-no-repeat" style={{ backgroundImage: `url(${heroBg})` }}>
      {/* Dark gradient overlay for text readability */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>
      
      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="flex flex-col items-center py-20 md:py-32 text-center">
          <div className="bg-white/90 backdrop-blur-sm rounded-2xl p-4 md:p-5 mb-8 animate-fade-in shadow-lg">
            <img
              src="/logo/ventura-power-washing-vertical.png"
              alt="Ventura Power Washing"
              width="700"
              height="962"
              className="h-36 md:h-48 w-auto"
            />
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight animate-fade-in">
            Expert Pressure Washing & Window Cleaning in Ventura County, CA
          </h1>
          
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-semibold mb-6 animate-fade-in" style={{ animationDelay: '0.1s' }}>
            Sparkling Exteriors & Fresh Carpets from Camarillo to Thousand Oaks
          </h2>
          
          <p className="text-xl md:text-2xl mb-8 max-w-4xl opacity-90 animate-fade-in" style={{ animationDelay: '0.2s' }}>
            Professional pressure washing, window cleaning, and carpet care for Ventura County homes. Eco-friendly. Satisfaction guaranteed. Free estimates.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 animate-fade-in" style={{ animationDelay: '0.4s' }}>
            <Link to="/free-estimate">
              <Button className="button-primary text-lg px-8 py-6 w-full sm:w-auto">
                Get a Free Estimate
                <ArrowRight className="ml-2" size={20} />
              </Button>
            </Link>
            
            <Button 
              className="bg-white text-ventura-blue hover:bg-gray-100 text-lg px-8 py-6" 
              onClick={() => window.location.href = "tel:+18054647166"}
            >
              <Phone className="mr-2" size={20} />
              Call Us Now
            </Button>
          </div>
          
          <div className="mt-12 bg-white bg-opacity-20 backdrop-blur-sm rounded-xl p-4 inline-block animate-fade-in" style={{ animationDelay: '0.6s' }}>
            <p className="text-lg font-medium">
              Serving Camarillo, Fillmore, Moorpark, Oxnard, Port Hueneme, Santa Paula, Simi Valley, Thousand Oaks, and Ventura
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
